import { emitThreadPagesPreload } from '#pplx/frontend/apps/ask/page-components/thread-pages-preload/threadPagesPreloadEvent.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useCallback } from 'react';
export function usePreloadThreadPagesOnIntent(selectedSearchMode) {
    const emitPreload = useCallback(() => {
        emitThreadPagesPreload(selectedSearchMode === SearchMode.ASI ? 'computer' : 'search');
    }, [selectedSearchMode]);
    const onKeyDown = useCallback(() => {
        emitPreload();
        return false;
    }, [emitPreload]);
    return { onClick: emitPreload, onKeyDown };
}
//# sourceMappingURL=usePreloadThreadPagesOnIntent.js.map